<template>
  <v-app id="app">
    <AccessibilitySkipLink :onTheTop="true" />
    <Header class="app-header" id="header" />
    <div class="mdn-Container-fluid" style="position: relative !important">
      <div class="mdn-Row" id="main">
        <div class="mdn-Col-lg">
          <router-view id="body" />
        </div>
      </div>
    </div>
    <Chat v-once />
    <Dialog
      :show-modal="showAlertMessage"
      :title="String($t('modalMessages.authAlertError.title'))"
      :description="String($t('modalMessages.authAlertError.description'))"
      is-dialog-type="warning"
      @isClose="hideAlertMessage"
      @buttonConfirmation="hideAlertMessage"
    />
    <Footer class="app-footer" id="footer" />
  </v-app>
</template>

<script lang="ts">
import Vue from "vue";
import { Action } from "vuex-class";
import { ActionMethod } from "vuex";
import { Component, Watch, Prop } from "vue-property-decorator";
import { Route } from "vue-router";
import BaseTeamCard from "@/components/widgets/BaseTeamCard.vue";

import Chat from "@/components/core/Chat.vue";
import AccessibilitySkipLink from "@/components/common/AccessibilitySkipLink.vue";
import Dialog from "@/components/common/Dialog/index.vue";

import Header from "@/components/header/index.vue";
import Footer from "@/components/footer/index.vue";

import "reflect-metadata";
import { eventBus } from "@/helpers/EventService";

@Component({
  components: {
    Footer,
    Header,
    BaseTeamCard,
    Chat,
    AccessibilitySkipLink,
    Dialog,
  },
})
export default class App extends Vue {
  @Action getFirebaseConfig!: ActionMethod;
  @Prop({ default: "" }) readonly uriChat!: string;
  showAlertMessage = false;
  showFooterFlag = false;
  customParentClass = "";
  hideFooterInRoutes: string[] = [
    "ForgotPassword",
    "Register",
    "Login",
    "SetPassword",
    "ResetPassword",
  ];

  @Watch("$route", {
    immediate: true,
    deep: true,
  })
  showFooter(newVal: Route): void {
    if (!newVal.name) {
      this.showFooterFlag = false;
      return;
    }
    this.showFooterFlag = !this.hideFooterInRoutes.includes(newVal.name);
    this.getParentClassName();
  }

  async getParentClassName(): Promise<void> {
    let path = this.$route.path || "";
    if (!path.length) {
      return;
    }
    path = path.replaceAll("/", " ").trim().split(" ").join("-");
    this.customParentClass = path.length ? path : "dashboard";
  }

  keyListener(e: KeyboardEvent) {
    const activeElement = document.activeElement;
    const inputs = ["input", "select", "textarea"];
    if (
      e.shiftKey &&
      activeElement &&
      inputs.indexOf(activeElement.tagName.toLowerCase()) === -1 &&
      (e.key.toLowerCase() === "f" ||
        e.key.toLowerCase() === "t" ||
        e.key.toLowerCase() === "c" ||
        e.key.toLowerCase() === "m")
    ) {
      e.preventDefault();
      switch (e.key.toLowerCase()) {
        case "f":
          setTimeout(() => {
            document.getElementById("footer")?.scrollIntoView();
            document.getElementById("footer")?.focus();
          }, 100);
          break;
        case "t":
          setTimeout(() => {
            document.getElementById("header")?.scrollIntoView();
            document.getElementById("header")?.focus();
          }, 100);
          document.getElementById("header-logo")?.focus();
          break;
        case "c":
          setTimeout(() => {
            document.getElementById("body")?.scrollIntoView();
            document.getElementById("body")?.focus();
          }, 100);
          break;
        case "m":
          setTimeout(() => {
            document.getElementById("main")?.scrollIntoView();
            document.getElementById("main")?.focus();
          }, 100);
          break;
      }
    }
  }

  mounted() {
    window.addEventListener("keypress", this.keyListener);
    eventBus.$on("authError", (isAuthError: boolean) => {
      if (isAuthError) {
        this.showAlertMessage = true;
      }
    });
  }

  beforeDestroy() {
    window.removeEventListener("keypress", this.keyListener);
  }

  hideAlertMessage() {
    this.showAlertMessage = false;
    this.$router.push({
      name: "Home",
    });
  }

  created() {
    this.getFirebaseConfig();
  }
}
</script>

<style lang="scss">
@import "~@/assets/theme/base-components.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
